/* Frete por CEP na página de produto e na gaveta do carrinho (roteiro T06).
   O formulário vem de snippets/atd-frete.liquid e só aparece quando o
   metacampo da loja atd.frete_url aponta para o intermediário (Cloudflare
   Worker), que guarda o token da Frenet e busca as medidas na Yampi, as
   mesmas do checkout. Ouvinte delegado no documento porque a gaveta é
   redesenhada por JavaScript. Testes em frete-worker/site.test.js. */
(function (w) {
  var reais = function (v) {
    return 'R$ ' + Number(v).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  };

  function limparCep(texto) {
    var cep = String(texto || '').replace(/\D/g, '');
    return cep.length === 8 ? cep : '';
  }

  function linhas(servicos) {
    var lista = (servicos || []).map(function (s) {
      var retirada = /retirada/i.test(s.nome);
      return {
        nome: retirada ? s.nome : s.nome + ' (' + s.transportadora + ')',
        prazo: s.prazo === 1 ? 'até 1 dia útil' : 'até ' + s.prazo + ' dias úteis',
        preco: s.preco > 0 ? reais(s.preco) : 'sem frete'
      };
    });
    var temRetirada = (servicos || []).some(function (s) { return /retirada/i.test(s.nome); });
    if (!temRetirada) lista.push({ nome: 'Retirada na loja em Goiânia', prazo: 'em até 24h', preco: 'sem frete' });
    return lista;
  }

  w.atdFrete = { limparCep: limparCep, linhas: linhas };
  if (!w.document || !w.document.querySelector) return;

  function itensDoProduto(form) {
    var qtd = 1;
    var campo = w.document.querySelector('product-form-component input[name="quantity"], form[action*="/cart/add"] input[name="quantity"]');
    if (campo && Number(campo.value) > 0) qtd = Number(campo.value);
    return Promise.resolve([{ sku: form.dataset.sku, qtd: qtd, valor: Number(form.dataset.valor) }]);
  }

  function itensDoCarrinho() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        return (c.items || []).filter(function (i) { return i.sku; }).map(function (i) {
          return { sku: i.sku, qtd: i.quantity, valor: i.final_price / 100 };
        });
      });
  }

  function pintar(caixa, html) { caixa.innerHTML = html; }

  w.document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('[data-atd-frete]');
    if (!form) return;
    e.preventDefault();
    var caixa = form.querySelector('.atd-frete__resultado');
    var cep = limparCep(form.querySelector('input[name="cep"]').value);
    if (!cep) { pintar(caixa, '<p class="atd-frete__aviso">Digite os 8 números do CEP.</p>'); return; }
    try { w.localStorage.setItem('atd-cep', cep); } catch (err) {}
    pintar(caixa, '<p class="atd-frete__aviso">Calculando…</p>');

    (form.hasAttribute('data-carrinho') ? itensDoCarrinho() : itensDoProduto(form))
      .then(function (itens) {
        if (!itens.length) throw new Error('sem itens');
        return fetch(form.dataset.url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ cep: cep, itens: itens })
        });
      })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok || !res.j.servicos) throw new Error(res.j && res.j.erro);
        pintar(caixa, '<ul class="atd-frete__lista" role="list">' + linhas(res.j.servicos).map(function (l) {
          return '<li><span class="atd-frete__nome">' + l.nome + '</span><span class="atd-frete__prazo">' + l.prazo +
            '</span><strong class="atd-frete__preco">' + l.preco + '</strong></li>';
        }).join('') + '</ul>');
      })
      .catch(function () {
        pintar(caixa, '<p class="atd-frete__aviso">Não deu para calcular agora. O frete aparece no checkout, com o seu CEP.</p>');
      });
  });

  w.document.addEventListener('focusin', function (e) {
    var campo = e.target;
    if (!campo.matches || !campo.matches('[data-atd-frete] input[name="cep"]') || campo.value) return;
    try { var salvo = w.localStorage.getItem('atd-cep'); if (salvo) campo.value = salvo.replace(/(\d{5})(\d{3})/, '$1-$2'); } catch (err) {}
  });
})(window);
